import { useSearchParams } from 'react-router';
import { api } from '../../api/client';
import { useAuth } from '../../auth/AuthContext';
import { DashboardView } from '../../components/DashboardView';
import { ErrorNotice, Loading } from '../../components/ui';
import { useAsync } from '../../lib/hooks';
import { paramsFromRange, queryFromParams } from '../../lib/period';

export function ClientDashboardPage() {
  const { me } = useAuth();
  const [params, setParams] = useSearchParams();
  // ?mes=2026-08 (um mês) ou ?de=2026-07&ate=2026-09 (intervalo). Sem nada: o mês mais recente com dados.
  const query = queryFromParams(params);
  const { data, error, loading, reload } = useAsync(() => api.myDashboard(query), [query?.period, query?.from, query?.to]);

  if (loading && !data) return <Loading label="Carregando seus resultados" />;
  if (error) return <ErrorNotice message={error} onRetry={reload} />;
  if (!data) return null;

  const firstName = me?.name.split(' ')[0];
  return (
    <div style={{ opacity: loading ? 0.6 : 1, transition: 'opacity .2s ease' }}>
      <DashboardView
        data={data}
        greeting={firstName ? `Olá, ${firstName}.` : undefined}
        deliverablesHref="/painel/entregaveis"
        onRangeChange={(r) => setParams(r.from === r.to && r.to === data.availablePeriods[0] ? {} : paramsFromRange(r))}
      />
    </div>
  );
}
